import { render, staticRenderFns } from "./QuickAddCollectModal.vue?vue&type=template&id=e8ab5214&scoped=true"
import script from "./QuickAddCollectModal.vue?vue&type=script&lang=js"
export * from "./QuickAddCollectModal.vue?vue&type=script&lang=js"
import style0 from "./QuickAddCollectModal.vue?vue&type=style&index=0&id=e8ab5214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ab5214",
  null
  
)

export default component.exports